/**
 * UI-related constants for Meteo
 */

// Icon sizes
export const ICON_SIZES = {
  WEATHER_MAIN: 50,
  WEATHER_INFO: 40,
  FORECAST: 30,
  SEARCH: 18,
} as const;

// CSS classes
export const CSS_CLASSES = {
  SEARCH_ENGINE: 'SearchEngine',
  CITY_SEARCH: 'city-search',
  CITY_NAME: 'city-name',
  DATE: 'date',
  TEMP: 'temp',
  TEMP_DEG: 'temp-deg',
  WEATHER_DES: 'weather-des',
  WEATHER_INFO: 'weather-info',
  COL: 'col',
  WIND: 'wind',
  HUMIDITY: 'humidity',
  FORECAST: 'forecast',
  FORECAST_CONTAINER: 'forecast-container',
  DAY: 'day',
  DAY_NAME: 'day-name',
  DAY_TEMPERATURE: 'day-temperature',
  ERROR_MESSAGE: 'error-message',
  HEADER: 'header',
  LANGUAGE_SELECTOR: 'language-selector',
  // Error handling classes
  ERROR_BOUNDARY: 'error-boundary',
  ERROR_BOUNDARY_CONTENT: 'error-boundary-content',
  ERROR_BOUNDARY_ICON: 'error-boundary-icon',
  ERROR_BOUNDARY_TITLE: 'error-boundary-title',
  ERROR_BOUNDARY_MESSAGE: 'error-boundary-message',
  ERROR_BOUNDARY_DETAILS: 'error-boundary-details',
  ERROR_BOUNDARY_ERROR_TYPE: 'error-boundary-error-type',
  ERROR_BOUNDARY_ERROR_MESSAGE: 'error-boundary-error-message',
  ERROR_BOUNDARY_ACTIONS: 'error-boundary-actions',
  ERROR_BOUNDARY_BUTTON: 'error-boundary-button',
  ERROR_DISPLAY: 'error-display',
  ERROR_DISPLAY_HEADER: 'error-display-header',
  ERROR_DISPLAY_ICON: 'error-display-icon',
  ERROR_DISPLAY_CONTENT: 'error-display-content',
  ERROR_DISPLAY_TITLE: 'error-display-title',
  ERROR_DISPLAY_MESSAGE: 'error-display-message',
  ERROR_DISPLAY_ACTIONS: 'error-display-actions',
  ERROR_DISPLAY_RETRY: 'error-display-retry',
  ERROR_DISPLAY_DISMISS: 'error-display-dismiss',
  ERROR_DISPLAY_TOGGLE: 'error-display-toggle',
  ERROR_DISPLAY_DETAILS: 'error-display-details',
  ERROR_DISPLAY_DETAIL_ITEM: 'error-display-detail-item',
  ERROR_LIST: 'error-list',
  ERROR_LIST_HEADER: 'error-list-header',
  ERROR_LIST_ITEM: 'error-list-item',
  ERROR_LIST_MORE: 'error-list-more',
  // Performance monitoring classes
  PERFORMANCE_DASHBOARD: 'performance-dashboard',
  PERFORMANCE_HEADER: 'performance-header',
  PERFORMANCE_CONTROLS: 'performance-controls',
  PERFORMANCE_CONTENT: 'performance-content',
  PERFORMANCE_SUMMARY: 'performance-summary',
  PERFORMANCE_SUMMARY_ITEM: 'performance-summary-item',
  PERFORMANCE_SORT: 'performance-sort',
  PERFORMANCE_COMPONENTS: 'performance-components',
  PERFORMANCE_COMPONENTS_HEADER: 'performance-components-header',
  PERFORMANCE_COMPONENT_ROW: 'performance-component-row',
  PERFORMANCE_COMPONENT_NAME: 'performance-component-name',
  PERFORMANCE_STATUS: 'performance-status',
} as const;

// Font sizes
export const FONT_SIZES = {
  SEARCH_ICON: '18px',
} as const;

// Fonts
export const FONTS = {
  DEFAULT: 'font',
} as const;
